/**
 * BUG-736: предупреждения ответа запроса — человеку на экран.
 *
 * `/api/qry` при группировке или сортировке по полю, которого нет у объекта (атрибут удалили, а вид
 * помнит), отвечает УСПЕХОМ и выбрасывает элемент с записью в `query.warnings` (CUB-885). Фронт их не
 * читал: отчёт тихо схлопывался в одну строку суммы или в сырые строки, и человек этого не видел.
 * План SaaS v1.8, §5 п. 3: предупреждение из warnings видно на экране.
 *
 * Где лежат: синхронный ответ — `result.query.warnings`, поток — `thread.result.query.warnings`.
 * Один и тот же набор не показывается чаще раза в 10 с (виды опрашивают потоки и перезапрашивают).
 */
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const RULES = [
  [/^groupby item '[^']*' dropped: entity `(\d+)` is not found on object '([^']*)'$/,
    m => `Группировка по полю ${m[1]} пропущена: такого поля нет у объекта «${m[2]}» (атрибут удалён?).`],
  [/^groupby item '[^']*' dropped: entity `(\d+)` is not found in this domain$/,
    m => `Группировка по полю ${m[1]} пропущена: такого поля нет в домене.`],
  [/^groupby ignored entirely/, () => 'Группировка не применена целиком — отчёт показан без свёртки, строки не сгруппированы.'],
  [/^orderby item '[^']*' dropped: entity `(\d+)` is not found on object '([^']*)'$/,
    m => `Сортировка по полю ${m[1]} пропущена: такого поля нет у объекта «${m[2]}».`],
  [/^orderby item '[^']*' dropped: entity `(\d+)` is not (found in this domain|among the query columns)$/,
    m => `Сортировка по полю ${m[1]} пропущена.`],
  [/^orderby ignored entirely/, () => 'Сортировка не применена — строки идут в порядке по умолчанию.'],
  [/^(user)?filter dropped: (.*)$/, m => `Условие отбора пропущено: ${m[2]}`],
  [/^(user)?filter: (.*)$/, m => `Отбор: ${m[2]}`],
]

export function warningText(w) {
  const s = String(w)
  const hit = RULES.map(([re, fmt]) => [s.match(re), fmt]).find(([m]) => m)
  return hit ? hit[1](hit[0]) : s
}

const shownUntil = new Map()

export default function showQueryWarnings(data) {
  const ws = (data && data.result && data.result.query && data.result.query.warnings)
    || (data && data.thread && data.thread.status === 'done' && data.thread.result
      && data.thread.result.query && data.thread.result.query.warnings)
  if (!Array.isArray(ws) || ws.length === 0 || !Vue.$toast) return
  const text = ws.map(warningText).join('\n')
  const now = Date.now()
  if ((shownUntil.get(text) || 0) > now) return
  shownUntil.set(text, now + 10000)
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title: 'Запрос выполнен с оговоркой', icon: 'AlertTriangleIcon', variant: 'warning', text,
    },
  }, { timeout: 12000 })
}
